module.exports = __webpack_public_path__ + "static/media/events.7fb335ba.svg";